import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function CompanyNews(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#BBEBFA"/>
      <path d="M15 11H17V13H15V11Z" fill="black" fillOpacity="0.54"/>
      <path d="M15 15H17V21H15V15Z" fill="black" fillOpacity="0.54"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M6 16C6 10.48 10.48 6 16 6C21.52 6 26 10.48 26 16C26 21.52 21.52 26 16 26C10.48 26 6 21.52 6 16ZM8 16C8 20.41 11.59 24 16 24C20.41 24 24 20.41 24 16C24 11.59 20.41 8 16 8C11.59 8 8 11.59 8 16Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
